import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=2f8d0b18&scoped=true&"
import script from "./Form.js?vue&type=script&lang=js&"
export * from "./Form.js?vue&type=script&lang=js&"
import style0 from "./Form.scss?vue&type=style&index=0&id=2f8d0b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8d0b18",
  null
  
)

export default component.exports